module.exports = __webpack_public_path__ + "static/fonts/CenturyGothic-Bold.fba7f11.woff";